import { useEffect, useLayoutEffect, useState } from "react"
import FocusTrap from "focus-trap-react"
// import { DidomiSDK } from "@didomi/react"

import { useConsole } from "contexts/Console"
import useScrollLock from "hooks/useScrollLock"

function didomi() {
  ;(function () {
    function i(e) {
      if (!window.frames[e]) {
        if (document.body && document.body.firstChild) {
          var t = document.body
          var n = document.createElement("iframe")
          n.style.display = "none"
          n.name = e
          n.title = e
          t.insertBefore(n, t.firstChild)
        } else {
          setTimeout(function () {
            i(e)
          }, 5)
        }
      }
    }

    function e(n, o, r, f, s) {
      function e(e, t, n, i) {
        if (typeof n !== "function") {
          return
        }
        if (!window[o]) {
          window[o] = []
        }
        var a = false
        if (s) {
          a = s(e, i, n)
        }
        if (!a) {
          window[o].push({
            command: e,
            version: t,
            callback: n,
            parameter: i,
          })
        }
      }
      e.stub = true
      e.stubVersion = 2
      function t(i) {
        if (!window[n] || window[n].stub !== true) {
          return
        }
        if (!i.data) {
          return
        }
        var a = typeof i.data === "string"
        var e
        try {
          e = a ? JSON.parse(i.data) : i.data
        } catch (t) {
          return
        }
        if (e[r]) {
          var o = e[r]
          window[n](
            o.command,
            o.version,
            function (e, t) {
              var n = {}
              n[f] = {
                returnValue: e,
                success: t,
                callId: o.callId,
              }
              if (i.source) {
                i.source.postMessage(a ? JSON.stringify(n) : n, "*")
              }
            },
            o.parameter
          )
        }
      }
      if (typeof window[n] !== "function") {
        window[n] = e
        if (window.addEventListener) {
          window.addEventListener("message", t, false)
        } else {
          window.attachEvent("onmessage", t)
        }
      }
    }

    e("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn")

    i("__tcfapiLocator")
  })()
  ;(function () {
    window.__gpp_addFrame = function (e) {
      if (!window.frames[e]) {
        if (document.body) {
          var t = document.createElement("iframe")
          t.style.cssText = "display:none"
          t.name = e
          document.body.appendChild(t)
        } else {
          window.setTimeout(window.__gpp_addFrame, 10, e)
        }
      }
    }

    window.__gpp_stub = function () {
      var e = arguments
      var __gpp
      __gpp.queue = __gpp.queue || []
      __gpp.events = __gpp.events || []
      if (!e.length || (e.length == 1 && e[0] == "queue")) {
        return __gpp.queue
      }
      if (e.length == 1 && e[0] == "events") {
        return __gpp.events
      }
      var t = e[0]
      var p = e.length > 1 ? e[1] : null
      var s = e.length > 2 ? e[2] : null
      if (t === "ping") {
        p(
          {
            gppVersion: "1.1",
            cmpStatus: "stub",
            cmpDisplayStatus: "hidden",
            signalStatus: "not ready",
            supportedAPIs: ["2:tcfeuv2", "5:tcfcav1", "6:uspv1", "7:usnat", "8:usca", "9:usva", "10:usco", "11:usut", "12:usct"],
            cmpId: "7",
            sectionList: [],
            applicableSections: [],
            gppString: "",
            parsedSections: {},
          },
          true
        )
      } else if (t === "addEventListener") {
        if (!("lastId" in __gpp)) {
          __gpp.lastId = 0
        }
        __gpp.lastId++
        var n = __gpp.lastId
        __gpp.events.push({
          id: n,
          callback: p,
          parameter: s,
        })
        p(
          {
            eventName: "listenerRegistered",
            listenerId: n,
            data: true,
            pingData: {
              gppVersion: "1.1",
              cmpStatus: "stub",
              cmpDisplayStatus: "hidden",
              signalStatus: "not ready",
              supportedAPIs: ["2:tcfeuv2", "5:tcfcav1", "6:uspv1", "7:usnat", "8:usca", "9:usva", "10:usco", "11:usut", "12:usct"],
              cmpId: "7",
              sectionList: [],
              applicableSections: [],
              gppString: "",
              parsedSections: {},
            },
          },
          true
        )
      } else if (t === "removeEventListener") {
        var a = false
        for (var i = 0; i < __gpp.events.length; i++) {
          if (__gpp.events[i].id == s) {
            __gpp.events.splice(i, 1)
            a = true
            break
          }
        }
        p(
          {
            eventName: "listenerRemoved",
            listenerId: s,
            data: a,
            pingData: {
              gppVersion: "1.1",
              cmpStatus: "stub",
              cmpDisplayStatus: "hidden",
              signalStatus: "not ready",
              supportedAPIs: ["2:tcfeuv2", "5:tcfcav1", "6:uspv1", "7:usnat", "8:usca", "9:usva", "10:usco", "11:usut", "12:usct"],
              cmpId: "7",
              sectionList: [],
              applicableSections: [],
              gppString: "",
              parsedSections: {},
            },
          },
          true
        )
      } else if (t === "hasSection") {
        p(false, true)
      } else if (t === "getSection" || t === "getField") {
        p(null, true)
      } else {
        __gpp.queue.push([].slice.apply(e))
      }
    }

    window.__gpp_msghandler = function (s) {
      var n = typeof s.data === "string"
      try {
        var e = n ? JSON.parse(s.data) : s.data
      } catch (t) {
        var e = null
      }
      if (typeof e === "object" && e !== null && "__gppCall" in e) {
        var a = e.__gppCall
        window.__gpp(
          a.command,
          function (e, t) {
            var p = {
              __gppReturn: {
                returnValue: e,
                success: t,
                callId: a.callId,
              },
            }
            s.source.postMessage(n ? JSON.stringify(p) : p, "*")
          },
          "parameter" in a ? a.parameter : null,
          "version" in a ? a.version : "1.1"
        )
      }
    }

    if (!("__gpp" in window) || typeof window.__gpp !== "function") {
      window.__gpp = window.__gpp_stub
      window.addEventListener("message", window.__gpp_msghandler, false)
      window.__gpp_addFrame("__gppLocator")
    }
  })()
  ;(function () {
    ;(function (e, i, o) {
      var n = document.createElement("link")
      n.rel = "preconnect"
      n.as = "script"
      var t = document.createElement("link")
      t.rel = "dns-prefetch"
      t.as = "script"
      var r = document.createElement("script")
      r.id = "spcloader"
      r.type = "text/javascript"
      r["async"] = true
      r.charset = "utf-8"
      window.didomiConfig = window.didomiConfig || {}
      window.didomiConfig.sdkPath = window.didomiConfig.sdkPath || o || "https://sdk.privacy-center.org/"
      const d = window.didomiConfig.sdkPath
      var a = d + e + "/loader.js?target_type=notice&target=" + i
      if (window.didomiConfig && window.didomiConfig.user) {
        var c = window.didomiConfig.user
        var s = c.country
        var f = c.region
        if (s) {
          a = a + "&country=" + s
          if (f) {
            a = a + "&region=" + f
          }
        }
      }
      n.href = d
      t.href = d
      r.src = a
      var m = document.getElementsByTagName("script")[0]
      m.parentNode.insertBefore(n, m)
      m.parentNode.insertBefore(t, m)
      m.parentNode.insertBefore(r, m)
    })("0bdf6b07-bba1-41f7-ab54-227f5ce36166", "GJzgAmkz")
  })()
}

export default function Didomi() {
  const console = useConsole()

  const scrollLock = useScrollLock()

  const [isActive, setIsActive] = useState(false)

  if (process.browser) {
    // didomi(env)
    didomi()
    didomi = Function.prototype // make sure that the script only runs once
  }

  function onNoticeShown(e) {
    window.didomiOnReady = window.didomiOnReady || []
    window.didomiOnReady.push(Didomi => {
      if (Didomi.isRegulationApplied("gdpr")) {
        setIsActive(true)
        window.localStorage.setItem("isGdprOpen", JSON.stringify(true))
        scrollLock.lock(document.body)
      }
    })
  }

  function onNoticeHidden(e) {
    setIsActive(false)
    window.localStorage.setItem("isGdprOpen", JSON.stringify(false))
    scrollLock.unlock(document.body)
    let gdprClosed = new CustomEvent("gdprClosed")
    window.dispatchEvent(gdprClosed)
  }

  useEffect(() => {
    window.didomiEventListeners = window.didomiEventListeners || []
    window.didomiEventListeners.push(
      {
        event: "notice.shown",
        listener: onNoticeShown,
      },
      {
        event: "notice.hidden",
        listener: onNoticeHidden,
      }
    )

    window.didomiOnReady = window.didomiOnReady || []
    window.didomiOnReady.push(function (Didomi) {
      const status = Didomi.getCurrentUserStatus()

      const dynatraceConsent = status.vendors["dynatrace-wTai4hJA"] ? status.vendors["dynatrace-wTai4hJA"].enabled : undefined

      // Écoute en continu (recommandé pour piloter Dynatrace)
      Didomi.addVendorStatusListener("dynatrace-wTai4hJA", function (vendorStatus) {
        console.log("Dynatrace enabled:", vendorStatus.enabled)

        if (window.dtrum) {
          window.dtrum.enable()
        }
      })
    })
  }, [])

  return isActive ? (
    <FocusTrap
      active={isActive}
      focusTrapOptions={{
        initialFocus: false,
        fallbackFocus: "#didomi-host",
        preventScroll: true,
      }}
      containerElements={["#didomi-host"]}
    />
  ) : null
  // return null
}
